export default "__VITE_ASSET__DALPbffi__"